<template>
    <v-dialog v-model="model" width="950">
        <toolbar-page dense disable-icon :title="name">
            <template slot="buttons">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn id="closeButton" @click="closeDialogClicked" v-on="on" icon>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close this dialog</span>
                </v-tooltip>
            </template>
        </toolbar-page>
        <v-card flat>

            <v-card-title>
                DESCRIPTION
            </v-card-title>

            <v-card-text class="pt-1 pb-1" v-html="filterLinks(description)">
            </v-card-text>

            <v-card-title>
                TERMS AND CONDITIONS
            </v-card-title>

            <v-card-text class="pt-1 pb-1" v-html="filterLinks(terms)">
            </v-card-text>

            <v-card-title v-if="redemptionInstructions">
                REDEMPTION INSTRUCTIONS
            </v-card-title>

            <v-card-text v-if="redemptionInstructions" class="pt-1 pb-1" v-html="filterLinks(redemptionInstructions)">
            </v-card-text>

            <v-card-title v-if="disclaimer">
                DISCLAIMER
            </v-card-title>

            <v-card-text v-if="disclaimer" class="pt-1 pb-1" v-html="filterLinks(disclaimer)">
            </v-card-text>

        </v-card>

    </v-dialog>
</template>

<script>
import ToolbarPage from "../../../../components/UI/ToolbarPage";

export default {

    components: {
        ToolbarPage
    },

    props: {

        value: {
            type: Boolean,
            required: true,
        },

        name: {
            type: String,
            required: true,
        },

        disclaimer: {
            type: String | null,
            required: true,
            default: null,
        },

        description: {
            type: String,
            required: true,
        },

        terms: {
            type: String,
            required: true,
        },

        redemptionInstructions: {
            type: String | null,
            required: false,
            default: null,
        }
    },

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },

    methods: {
        filterLinks(html) {
            if (html) {
                return html.replace(/<a\b[^>]*>/ig, "").replace(/<\/a>/ig, "");
            }
        },

        closeDialogClicked() {
            this.$emit('input', false);
        }
    }
}
</script>
